import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin-bottom: 56px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyledHeaderContainer = styled.div`
  box-sizing: border-box;
  padding: 24px;
  background: #fefefe;
  border-radius: 4px;

  max-width: 100%;
  width: 100%;
  min-height: 112px;

  margin-bottom: 24px;

  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  column-gap: 40px;
`

export const StyledLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 16px;
`

export const StyledRightContainer = styled.div`
  display: flex;
  flex-direction: row !important;
  flex-direction: column;
  justify-content: center;
  column-gap: 20px;
`

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`

export const StyledImg = styled.img``

export const StyledName = styled.h3`
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #38003c;
`

export const StyledDescription = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #120224;
`

export const StyledOptionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const StyledHeading = styled.h3`
  font-weight: 600;
  margin-bottom: 16px;
`
